import {
  FETCH_INVENTORYLIST_REQUEST,
  FETCH_INVENTORYLIST_SUCCESS,
  FETCH_INVENTORYLIST_FAILURE,
} from "./inventoryListTypes";

const initialState = {
  loading: false,
  inventoryList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVENTORYLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_INVENTORYLIST_SUCCESS:
      return {
        loading: false,
        inventoryList: action.payload,
        error: "",
      };
    case FETCH_INVENTORYLIST_FAILURE:
      return {
        loading: false,
        inventoryList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
